// src/layouts/MainLayout.js
import React from "react";
import { useLocation } from "react-router-dom";
import "../MainLayout/MainLayout.css";
import SubPageHeader from "../../Header/SubHeader/SubPageHeader";
import SubFooter from "../../Footer/SubFooter/SubFooter";
import InfoCardsSection from "../../CommonWidgets/InfoCardsSection/InfoCardsSection";

export default function SeconderyLayout({ children }) {
  const location = useLocation();

  const showInfoCardsOn = [
    "/AimAndScope",
    "/AuthorsGuideline",
    "/Topics",
    "/Fees",
    "/Volumes",
  ];

  const shouldShowInfoCards = showInfoCardsOn.includes(location.pathname);

  return (
    <div className="ijacna-layout">
      <SubPageHeader />
      {children}
      {shouldShowInfoCards && (
        <div className="ijacna-info-cards-section-wrapper">
          <InfoCardsSection />
        </div>
      )}

      <SubFooter />
    </div>
  );
}
